/**
 * Persists project-invite keys across login, MFA, and 2FA setup (same idea as shared_doc_id).
 */
export const PENDING_INVITE_SESSION_KEY = 'lens_pending_invite_key';

export function stashInviteKeyFromSearch(search) {
    const inv = new URLSearchParams(search).get('invite');
    if (inv) {
        sessionStorage.setItem(PENDING_INVITE_SESSION_KEY, inv);
        return inv;
    }
    return sessionStorage.getItem(PENDING_INVITE_SESSION_KEY);
}

export function peekPendingInviteKey() {
    return sessionStorage.getItem(PENDING_INVITE_SESSION_KEY);
}

export function consumePendingInviteKey() {
    const k = sessionStorage.getItem(PENDING_INVITE_SESSION_KEY);
    if (k) {
        sessionStorage.removeItem(PENDING_INVITE_SESSION_KEY);
    }
    return k;
}

/** Prevents a second routeAfterLogin (OAuth / StrictMode) from routing to select-workspace after invite consume. */
const ROUTE_AFTER_LOGIN_INVITE_LOCK = 'lens_invite_route_after_login_lock';

export function setRouteAfterLoginInviteLock(inviteKey) {
    if (inviteKey) {
        sessionStorage.setItem(ROUTE_AFTER_LOGIN_INVITE_LOCK, String(inviteKey));
    }
}

export function clearRouteAfterLoginInviteLock() {
    sessionStorage.removeItem(ROUTE_AFTER_LOGIN_INVITE_LOCK);
}

export function hasRouteAfterLoginInviteLock() {
    return Boolean(sessionStorage.getItem(ROUTE_AFTER_LOGIN_INVITE_LOCK));
}

/** Set when routing new users to /register/:key so post–2FA signup returns to validate-invite. */
export const PENDING_POST_REGISTER_VALIDATE_KEY = 'lens_post_register_validate_invite_key';

export function stashPostRegisterValidateKey(key) {
    if (key) {
        sessionStorage.setItem(PENDING_POST_REGISTER_VALIDATE_KEY, key);
    }
}

export function takePostRegisterValidateKey() {
    const k = sessionStorage.getItem(PENDING_POST_REGISTER_VALIDATE_KEY);
    if (k) {
        sessionStorage.removeItem(PENDING_POST_REGISTER_VALIDATE_KEY);
    }
    return k;
}
